export default function (_ctx, inject) {
  const domParser = new DOMParser();

  inject("domParser", domParser);
}
